import api from './api';
import { Tenant } from '../types/tenant';

export const getAllTenants = async (
  page: number,
  pageSize: number,
  sortBy: string,
  order: 'asc' | 'desc',
  searchTerm: string
): Promise<{ tenants: Tenant[], total: number }> => {
  const response = await api.get('/tenants', {
    params: { page, pageSize, sortBy, order, searchTerm },
  });
  return {
    tenants: response.data.tenants,
    total: response.data.total,
  };
};

export const createTenant = async (tenantData: Partial<Tenant>): Promise<Tenant> => {
  const response = await api.post('/tenants', tenantData);
  return response.data;
};

export const updateTenant = async (tenantId: string, tenantData: Partial<Tenant>): Promise<Tenant> => {
  const response = await api.put(`/tenants/${tenantId}`, tenantData);
  return response.data;
};

export const deleteTenant = async (tenantId: string): Promise<void> => {
  await api.delete(`/tenants/${tenantId}`);
};

/** Imposta il PIN del bar: solo l'admin. */
export const setBarPin = async (tenantId: string, pin: string): Promise<void> => {
  await api.put(`/tenants/${tenantId}/bar-pin`, { pin });
};

/** Carica o sostituisce il logo della scuola (gia' ridotto dal browser). */
export const uploadTenantLogo = async (tenantId: string, variant: 'light' | 'dark', logo: Blob): Promise<Tenant> => {
  const form = new FormData();
  form.append('logo', logo, 'logo.png');
  const response = await api.post(`/tenants/${tenantId}/logo/${variant}`, form);
  return response.data;
};

export const deleteTenantLogo = async (tenantId: string, variant: 'light' | 'dark'): Promise<Tenant> => {
  const response = await api.delete(`/tenants/${tenantId}/logo/${variant}`);
  return response.data;
};

export const testEmail = async (tenantId: string, smtpConfig: any): Promise<void> => {
    await api.post(`/tenants/${tenantId}/test-email`, smtpConfig);
};

export const sendDailyStaffReport = async (tenantId: string, date?: string): Promise<void> => {
    await api.post(`/tenants/${tenantId}/send-daily-report`, { date });
};
